import useSwr from "swr";
import { GetPartnerQuery, GetProductQuery } from "../dto/commons";
import {
  getBranches,
  getPartners,
  getProducts,
} from "../services/commons.service";

const queryKeys = {
  "get.products": (query: GetProductQuery) =>
    `products?${Object.entries(query)
      .map(([k, v]) => `${k}=${v}`)
      .join("&")}`,
};

export const useBranches = () => {
  return useSwr("branches", getBranches, {
    revalidateOnFocus: false,
  });
};

export const usePartners = (query: GetPartnerQuery) => {
  return useSwr(`partners/${query.type}`, () => getPartners(query), {
    revalidateOnFocus: false,
  });
};

export const useProducts = (query: GetProductQuery) => {
  const key = queryKeys["get.products"](query);
  return useSwr(key, () => getProducts(query), {
    revalidateOnFocus: false,
  });
};
